module.exports = __webpack_public_path__ + "img/empty-search-img.f1c54aef.png";